export const ACTIVE_STEP_CTA_ID = 'active-step-cta'
export const API_ERROR_KEY = 'apiError'
export const CONTINUE_ONLINE_CTA_ID = 'continue-online-cta'
export const UNKNOWN_ERROR_TEXT = 'UNKNOWN_ERROR'
